import type { FeatureFlags } from '../utils/types/FeatureFlag';

import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import getFeatureFlags from '../utils/apiRestCalls/getFeatureFlags';

export const initialFeatureFlagValues: FeatureFlags = {
  test: false,
  enable_new_deals_dashboard: false,
  enable_new_renters_insurance_dashboard: false,
  enable_self_enrolled_1_month_SDR_limit: false,
  remove_marketing_meeting_split: false,
  'tiger-1497_ri_enrolled': false,
  'tiger-1549_enable_properties': false,
  'tiger-1520_monitoring_type': false,
  'MONARCH-319_new_coverages_on_landlord_invite': false,
  'otters-2375_enable_deals_dashboard_lease_dates_filters': false,
  'otters-2450_enable_deals_dashboard_updated_at_column': false,
  'otters-3500_remove_custom_coverage_from_institutional_invite': false,
  'otters-3634_enable_collect_lease_details_accordion': false,
  'otters-3792_enable_leasestartdate_filter_inprogress': false,
  'otters-3986_self_service_user_management_enabled': false,
  'otters-4078_self_service_user_management_milestone_2_enabled': false,
  'otters-4079_self_service_user_management_milestone_3_enabled': false,
  'otters-4215_allow_landlord_to_edit_renters_in_app_tracker': false,
  'dog-18_additional_claims_owed': false,
};

const featureflagStore = create(
  devtools<{
    featureFlags: FeatureFlags;
    useFetchFeatureFlags: () => void;
  }>((set) => ({
    featureFlags: initialFeatureFlagValues,
    useFetchFeatureFlags: () => {
      const { data: featureFlags } = useQuery({
        queryKey: ['featureFlag'],
        queryFn: () => getFeatureFlags(),
        staleTime: Infinity,
      });
      useEffect(() => {
        if (featureFlags) {
          set({ featureFlags });
        }
      }, [featureFlags]);
    },
  })),
);

export default featureflagStore;
